import styled from "styled-components";
import {DenmarkResponsibleGamingButtonBaseBox} from "../../boxes/denmark.responsible-gaming-button-base.box";
import {styledByDevice} from "../../../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled(DenmarkResponsibleGamingButtonBaseBox)`
  width: 120px;
  height: 20px;
`;


const PcBox = DefaultBox;
const MobileBox = styled(DefaultBox)`
    width: 90px;
    height: 15px;
`;

export const DenmarkSelfTestButtonBox = styledByDevice(PcBox, MobileBox);